export default __webpack_public_path__ + "static/media/img-screen.8e3e49a9.png";